<template>
  <div class="auth-page">
    <div class="auth-card">
      <h1>Новый пароль</h1>
      <p v-if="error" class="auth-error">{{ error }}</p>
      <p v-if="message" class="auth-note">{{ message }}</p>
      <q-input outlined v-model="password" type="password" label="Новый пароль" autocomplete="new-password" @keyup.enter="submit" />
      <q-btn color="primary" label="Сохранить пароль" :loading="loading" @click="submit" />
      <div class="auth-links">
        <router-link to="/login">Ко входу</router-link>
      </div>
    </div>
  </div>
</template>

<script>
import grpc from "@/services/grpc";

export default {
  name: 'ResetPasswordView',
  data() {
    return {
      password: '',
      error: '',
      message: '',
      loading: false,
      grpcClient: new grpc(),
    };
  },
  methods: {
    async submit() {
      this.error = '';
      this.message = '';
      const token = this.$route.query.token;
      if (!token) {
        this.error = 'В ссылке нет токена сброса.';
        return;
      }
      this.loading = true;
      try {
        await this.grpcClient.resetPassword(token, this.password);
        this.message = 'Пароль обновлён. Теперь можно войти.';
        this.password = '';
      } catch (err) {
        this.error = err.message || 'Не удалось обновить пароль';
      } finally {
        this.loading = false;
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.auth-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f6f8fb;
  padding: 24px;
}
.auth-card {
  width: min(420px, 100%);
  display: flex;
  flex-direction: column;
  gap: 14px;
  padding: 28px;
  background: #fff;
  border: 1px solid #e5eaf2;
  border-radius: 8px;
  text-align: left;
  h1 {
    margin: 0;
    color: #202938;
  }
  a {
    color: #1976d2;
  }
}
.auth-note, .auth-error {
  margin: 0;
}
.auth-note {
  color: #546179;
}
.auth-error {
  color: #c10015;
}
</style>
